<template>
  <div id="app">
    <router-view />
    <Onboard v-if="$store.getters.USER" />
  </div>
</template>

<script lang="ts">
import Onboard from "./components/Onboard.vue";
export default {
  components: {
    Onboard,
  },
  methods: {
    setDocHeight() {
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight / 100}px`
      );
    },
  },
  mounted() {
    this.setDocHeight();
    window.addEventListener("resize", () => {
      this.setDocHeight();
    });
    window.addEventListener("onrientationchange", () => {
      this.setDocHeight();
    });
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
